import React from 'react'
import { Button } from '@chakra-ui/react'

export const SubmitButton = () => {
  return (
    <Button type="submit" height="auto">
      Search
    </Button>
  )
}
